// extracted by mini-css-extract-plugin
export default {"container":"SearchResults_container__bY43j","results":"SearchResults_results__aD8vz","addItemButton":"SearchResults_addItemButton__0zNn-","link":"SearchResults_link__LKbfY"};